import {Box, Typography, Zoom} from '@mui/material';
import PropTypes from 'prop-types';

const LayoutTitle = ({title = ''}) => {
  return title?.length === 0 ? (
    <></>
  ) : (
    <Box
      sx={{
        marginTop: 0,
        display: 'flex',
        alignItems: 'center',
        mb: {xs: 4, lg: 5},
        mt: {xs: 0, lg: 0},
      }}
    >
      <Zoom in style={{transitionDelay: '300ms'}}>
        <Typography
          variant='h1'
          sx={{
            fontSize: {xs: 20, lg: 24},
            fontWeight: 800,
            textTransform: 'uppercase',
            letterSpacing: '2px', // The "Cockpit" tracking
            color: 'secondary.main', // Using your Onyx (YAMAN_ONYX)
            position: 'relative',
            '&:after': {
              content: '""',
              position: 'absolute',
              bottom: -4,
              left: 0,
              width: '20px',
              height: '2px',
              backgroundColor: 'primary.main', // Small Gold accent underline
            },
          }}
        >
          {title}
        </Typography>
      </Zoom>
    </Box>
  );
};

export default LayoutTitle;

LayoutTitle.propTypes = {
  title: PropTypes.string,
};
